// Urutan & label waktu cetak tab Sudah Dicetak (Rido Shopee).
const BULAN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
// "Dicetak 19 Okt, 10:35 WIB" — selalu zona Asia/Jakarta. Tanpa waktu valid → "".
export function fmtPrintedWib(iso) {
  const t = Date.parse(iso || "");
  if (!iso || Number.isNaN(t)) return "";
  const d = new Date(t + 7 * 3600 * 1000);
  const pad = (n) => String(n).padStart(2, "0");
  return `Dicetak ${d.getUTCDate()} ${BULAN[d.getUTCMonth()]}, ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} WIB`;
}
// Urut Sudah Dicetak berdasar mockup_printed_at. Data lama tanpa waktu valid selalu di bawah
// (urut waktu kirim ke Gudang terbaru, lalu nomor pesanan) — tanpa timestamp buatan.
export function sortPrinted(list, dir = "desc") {
  const pt = (j) => { const t = Date.parse(j.mockup_printed_at || ""); return Number.isNaN(t) ? null : t; };
  const st = (j) => Date.parse(j.warehouse_sent_at || "") || 0;
  return list.slice().sort((a, b) => {
    const x = pt(a), y = pt(b);
    if (x === null || y === null) return x === null && y === null ? (st(b) - st(a) || String(a.order_number).localeCompare(String(b.order_number))) : x === null ? 1 : -1;
    return (dir === "asc" ? x - y : y - x) || String(a.order_number).localeCompare(String(b.order_number));
  });
}
